"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, FormSection, FormActions, FormField, Input, Button } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsFormSection() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Form Section
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            Organizes form fields into logical sections with titles and descriptions.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/form-section" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>Form sections with actions</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <div className="space-y-8">
            <FormSection
              title="Personal Information"
              description="Enter your personal details below."
            >
              <div className="grid grid-cols-2 gap-4">
                <FormField htmlFor="firstName" label="First Name">
                  <Input id="firstName" placeholder="John" />
                </FormField>
                <FormField htmlFor="lastName" label="Last Name">
                  <Input id="lastName" placeholder="Doe" />
                </FormField>
              </div>
            </FormSection>

            <FormSection
              title="Contact Information"
              description="How can we reach you?"
            >
              <FormField htmlFor="contactEmail" label="Email">
                <Input id="contactEmail" type="email" placeholder="john@example.com" />
              </FormField>
            </FormSection>

            <FormActions>
              <Button variant="outline">Cancel</Button>
              <Button>Save</Button>
            </FormActions>
          </div>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Component</th>
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">FormSection</td>
                <td className="py-2 font-mono text-xs">title</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Section title</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">FormSection</td>
                <td className="py-2 font-mono text-xs">description</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Section description</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">FormActions</td>
                <td className="py-2 font-mono text-xs">children</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">ReactNode</td>
                <td className="py-2 text-muted-foreground">Action buttons</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
